import React from "react";

const ServiceItem = (props) => {
  const { icon, title, description } = props.service;
  return (
    <div className="w-full lg:w-1/2 p-2 md:p-3" data-scroll-reveal>
      <div className="h-full relative rounded-2xl overflow-hidden group">
        {/* Glass background */}
        <div className="absolute inset-0 bg-white/70 backdrop-blur-md" />

        {/* Gradient border */}
        <div className="absolute inset-0 rounded-2xl p-[2px] bg-gradient-to-br from-green-400/30 to-blue-400/20" />

        {/* Content */}
        <div className="relative z-10 h-full flex flex-col p-6 rounded-2xl border border-white/40 shadow-xl shadow-green-500/5 hover:shadow-xl hover:shadow-green-500/20 transition-all duration-300">
          {/* Icon with glow */}
          <div className="relative w-14 h-14 flex items-center justify-center rounded-xl text-2xl mb-4 bg-gradient-to-br from-green-100 to-blue-100 text-green-600 transition-all duration-200 group-hover:shadow-lg group-hover:shadow-green-400/40 group-hover:scale-110">
            <div className="absolute inset-0 bg-gradient-to-br from-green-400/20 to-emerald-400/20 rounded-xl blur-md opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="relative">{icon}</div>
          </div>

          <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 group-hover:text-green-600 transition-colors">
            {title}
          </h3>
          <p className="text-sm md:text-base text-gray-700 leading-relaxed flex-grow font-light">
            {description}
          </p>

          {/* Bottom accent line */}
          <div className="mt-4 pt-3 border-t border-green-200/30 opacity-0 group-hover:opacity-100 transition-opacity">
            <div className="h-0.5 w-8 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceItem;
